export const getPercentage = (progress, total) => Math.round(progress / total * 100);

export const getMaxInvoiceSum = (invoices) => Math.max(...invoices.map(({ amount }) => amount));

export const getAmountPayment = (invoices) => invoices.reduce((amount, item) => amount + item.unpaidAmount, 0);

export const isAllPaid = (invoices) => invoices.every((item) => item.status === 'Paid');
